<!--Ez az Admin login-->
<template class="my-auto">
  <div class="text-center center py-auto d-flex">
    <v-card outlined elevation="2" class="ma-auto pa-2 login-card">

      <img src="@/assets/sze_logo.png" class="logo mb-1" />
      <p class="text-uppercase mb-0">{{ $store.state.lang.tanulmanyi_tajekoztato }}</p>
      <p class="text-uppercase mb-0">{{ $store.state.lang.admin_felulet }}</p>

      <v-divider class="mx-2 uni_blue2 size"></v-divider>
      {{ studentName }}
      <v-text-field label="NeptunKód" class="ma-3" color="uni_blue2" :error-messages="errors.neptunCode"
        v-model="user.neptunCode" v-on:keyup.enter="Login" :disabled="logged" />
      <v-text-field :label="$store.state.lang.login_jelszo" class="ma-3" color="uni_blue2"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" @click:append="show = !show"
        :error-messages="errors.password" v-model="user.password" v-on:keyup.enter="Login" :disabled="logged" />
      <v-combobox label="Mintatanterv" class="ma-3" color="uni_blue2" item-color="uni_blue2" :items="sample_plans"
        item-text="Mintatanterv_nev" item-value="Mintatanterv_kod" v-if="showMintatantev" v-model="selectedSamplePlan">
      </v-combobox>
      <v-row class="mb-1">
        <v-col :cols="12" :lg="12" :md="12">
          <v-row>
            <v-col :cols="12" :lg="12" :md="12" :sm="12" v-if="!showMintatantev">
              <v-btn dark color="uni_blue" @click="Login">{{ $store.state.lang.bejelentkezes }}</v-btn>
            </v-col>
            <v-col :cols="12" :lg="12" :md="12" :sm="12">
              <v-btn dark v-if="showMintatantev" color="uni_blue" @click="goToMatrix">
                Mátrix
              </v-btn>
            </v-col>
            <v-col :cols="12" :lg="12" :md="12" :sm="12">
              <v-btn dark v-if="showMintatantev" color="uni_blue" @click="Logout">
                Hallgató váltás
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>

export default {
  data: () => ({
    show: false,
    user: {
      neptunCode: "",
      password: "",
    },
    errors: {
      neptunCode: "",
      password: "",
    },
    selectedSamplePlan: "",
    showMintatantev: false,
    sample_plans: [],
    logged: false,
    studentName: "",
    student: {},
  }),
  beforeMount() {
    this.params = this.$route.params.id;
    if (this.params != "l5l3bVZgWL3AFhiiu8wfEBvkhLN4N5") {
      this.$router.push("/");
    }
  },
  methods: {
    async Login() {
      this.alert = false;
      this.errors = {
        neptunCode: "",
        password: "",
      };
      try {
        if (this.user.neptunCode.length != 6) {
          this.errors.neptunCode = "Nem megfelelő neptunkód";
          return;
        }
        const response = await this.$http.post("/loginTeszt", this.user);
        if (Object.keys(response.errors).length > 0) {
          const alert = {
            show: true,
            type: "error",
            message: response.errors.message
          };
          this.$store.dispatch("showAlert", alert);
          return;
        } else {
          this.showMintatantev = true;
          this.logged = true;
          this.sample_plans = response.sample_plans;
          this.studentName = response.student.F1;
          this.student = response.student;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async goToMatrix() {
      this.$router.push(
        "/tanulo_matrix/hu/" +
        this.selectedSamplePlan.Modulkod +
        "/" +
        this.selectedSamplePlan.Mintatanterv_kod
      );

    },

    Logout() {
      this.user.neptunCode = "";
      this.user.password = "";
      this.sample_plans = [];
      this.showMintatantev = false;
      this.logged = false;
      this.studentName = "";
    },
  },
};
</script>

<style>
.login-card {
  width: 500px;
  max-width: 90%;
}

.center {
  min-height: 100%;
}

.margin {
  margin: auto;
}

.size {
  font-size: 30px;
}

.logo {
  width: 80%;
  max-width: 300px;
}
</style>